/**
 * UI locale for Info help.
 * Screen labels stay English. Info title and body follow the language set on the system.
 */
export const DEFAULT_LOCALE = 'en-NZ';
export const SUPPORTED_LOCALES = ['en-NZ', 'en', 'ko'];

function languageList() {
  if (typeof navigator === 'undefined') return ['en'];
  const listed = navigator.languages;
  if (listed && listed.length) return Array.from(listed);
  return [navigator.language || navigator.userLanguage || 'en'];
}

/**
 * Info language.
 * Korean when the system language list starts with Korean, or when Korean is
 * listed and the only language ahead of it is generic en-US (an embedded
 * browser default on a Korean Windows PC). An explicit English such as en-NZ
 * ahead of Korean stays English.
 */
export function resolveUiLocale() {
  const list = languageList().map((raw) => String(raw || ''));
  const bases = list.map((raw) => raw.toLowerCase().split('-')[0]);
  const koAt = bases.indexOf('ko');
  if (koAt === 0) return 'ko';
  if (koAt > 0) {
    const explicitEnglish = list.slice(0, koAt).some((raw) => {
      const lower = raw.toLowerCase();
      return lower.startsWith('en') && lower !== 'en-us';
    });
    if (!explicitEnglish) return 'ko';
  }
  return 'en';
}
